
// Google Calendar Documentation: https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/google.md
const GCAL_BASE_URL = "https://calendar.google.com/calendar/render?action=TEMPLATE";
const GCAL_TEXT_PREFIX = "&text=";
const GCAL_DATES_PREFIX = "&dates=";
const GCAL_SPROP_WEBSITE_PREFIX = "&sprop=website:";
const GCAL_SPROP_NAME_PREFIX = "&sprop=name:";
const GCAL_LOCATION_PREFIX = "&location=";

// iCalendar Documentation: https://icalendar.org/

const ICAL_FILENAME = "election.ics";

const ICAL_TEMPLATE = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//hacksw/handcal//NONSGML v1.0//EN
BEGIN:VEVENT
UID:[ICAL_KEY_UID]
DTSTART:[ICAL_KEY_START_DATE]
DTEND:[ICAL_KEY_END_DATE]
SUMMARY:[ICAL_KEY_SUMMARY]
END:VEVENT
END:VCALENDAR`;

const ICAL_KEY_UID = "[ICAL_KEY_UID]";
const ICAL_KEY_START_DATE = "[ICAL_KEY_START_DATE]";
const ICAL_KEY_END_DATE = "[ICAL_KEY_END_DATE]";
const ICAL_KEY_SUMMARY = "[ICAL_KEY_SUMMARY]"

export default {
  GCAL_BASE_URL,
  GCAL_TEXT_PREFIX,
  GCAL_DATES_PREFIX,
  GCAL_SPROP_WEBSITE_PREFIX,
  GCAL_SPROP_NAME_PREFIX,
  GCAL_LOCATION_PREFIX,
  ICAL_FILENAME,
  ICAL_TEMPLATE,
  ICAL_KEY_UID,
  ICAL_KEY_START_DATE,
  ICAL_KEY_END_DATE,
  ICAL_KEY_SUMMARY
}